import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, DatePipe } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  APP_INITIALIZER,
} from '@angular/core';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
  HttpBackend,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';

import { NgCircleProgressModule } from 'ng-circle-progress';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeDe from '@angular/common/locales/de';
import localeTr from '@angular/common/locales/tr';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import {
  TippyModule,
  tooltipVariation,
  popperVariation,
} from '@ngneat/helipopper';

import { VideoService } from './services/video.service';

import { AppComponent } from './app.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ToastrModule } from 'ngx-toastr';
import { YesNoPipe } from './shared/pipes/yes-no.pipe';
import { MissingTranslationHelper } from './shared/pipes/missing-translation-helper.pipe';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';
import { Interceptor } from './services/interceptor/interceptor';
import { AuthService } from './services/auth.service';
import { ModalComponent } from '@components/modal/modal.component';

import { StoreModule } from '@ngrx/store';
import { FilterDeletedExercisesPipe } from './shared/pipes/filter-deleted-exercises.pipe';
import { NgToggleModule } from 'ng-toggle-button';

import { OldPasswordComponent } from './views/reset-password/old-password/old-password.component';
import { OldEmailComponent } from './views/old-email/old-email.component';
import { ChangeEmailComponent } from './views/change-email/change-email.component';
import { SettingsScreenComponent } from './views/settings-screen/settings-screen.component';
import { NotificationsComponent } from '@pages/notifications/notifications.component';

import { ProgressBarsComponent } from './views/shared/progress-bars/progress-bars.component';
import { ModalService } from '@services/modal.service';
import { PatientMessageComponent } from './views/patient-message/patient-message.component';
import { InformationComponent } from './views/information/information.component';
import { environment } from '@environments/environment';
import { SharedUiModule } from './shared/ui/shared-ui.module';
import { NotificationListModule } from './views/shared/notification-list/notification-list.module';

/* breathment FIREBASE CONFIG */

// const firebaseConfig = {
//   apiKey: "AIzaSyB29PLgHpO310Ko0Rvv1iWYqvGfO8EoaTU",
//   authDomain: "breathment.firebaseapp.com",
//   databaseURL: "https://breathment.firebaseio.com",
//   projectId: "breathment",
//   storageBucket: "breathment.appspot.com",
//   messagingSenderId: "239464058104",
//   appId: "1:239464058104:web:48af46be4a0055fa50ff0d",
//   measurementId: "G-SH4S7G33SV"
// };
/* breathment FIREBASE CONFIG */

/* breathment-staging FIREBASE CONFIG */

// const firebaseConfig = {
//   apiKey: "AIzaSyC2ICUWv9Wizalzc3Fu3LWB4a0gjJTW_00",
//   authDomain: "breathment-staging.firebaseapp.com",
//   databaseURL: "https://breathment-staging-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "breathment-staging",
//   storageBucket: "breathment-staging.appspot.com",
//   messagingSenderId: "97537147854",
//   appId: "1:97537147854:web:6308c4af928e9886e9619f",
//   measurementId: "G-DNZYYRMQQP"
// };
/* breathment-staging FIREBASE CONFIG */

/* breathment-production FIREBASE CONFIG */

// const firebaseConfig = {
//   apiKey: 'AIzaSyB6ramrl6sO_kyoQ_6A3-ht7RPNAL-TYQY',
//   authDomain: 'breathment-production-bc2ad.firebaseapp.com',
//   projectId: 'breathment-production-bc2ad',
//   storageBucket: 'breathment-production-bc2ad.appspot.com',
//   messagingSenderId: '692331334043',
//   appId: '1:692331334043:web:7dfed943a65c02c943b93e',
//   measurementId: 'G-KDNVHYR947',
// };
// /* breathment-production FIREBASE CONFIG */

const firebaseConfig = {
  apiKey: 'AIzaSyB6ramrl6sO_kyoQ_6A3-ht7RPNAL-TYQY',
  authDomain: 'breathment-production-bc2ad.firebaseapp.com',
  projectId: 'breathment-production-bc2ad',
  storageBucket: environment.firebaseStorageBucket,
  messagingSenderId: '692331334043',
  appId: '1:692331334043:web:7dfed943a65c02c943b93e',
  measurementId: 'G-KDNVHYR947',
};
// /* breathment-production FIREBASE CONFIG */

export function HttpLoaderFactory(handler: HttpBackend) {
  const http = new HttpClient(handler);
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
registerLocaleData(localeDe);
registerLocaleData(localeTr);
registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    YesNoPipe,
    ModalComponent,
    FilterDeletedExercisesPipe,
    OldPasswordComponent,
    OldEmailComponent,
    ChangeEmailComponent,
    SettingsScreenComponent,
    NotificationsComponent,
    ProgressBarsComponent,
    PatientMessageComponent,
    InformationComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    SharedUiModule,
    NotificationListModule,
    HttpClientModule,
    NgbModule,
    OverlayModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingTranslationHelper,
      },
    }),
    NgCircleProgressModule.forRoot({
      // set defaults here
      // "radius": 60,
      space: -10,
      unitsFontSize: '13',
      unitsFontWeight: '400',
      outerStrokeGradient: false,
      outerStrokeWidth: 10,
      outerStrokeColor: '#4882c2',
      innerStrokeColor: '#e7e8ea',
      innerStrokeWidth: 10,
      subtitleFontSize: '31',
      subtitleFontWeight: '300',
      animateTitle: false,
      animationDuration: 1000,
      showTitle: false,
      showSubtitle: true,
      showUnits: false,
      showBackground: false,
      responsive: true,
      lazy: false,
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ToastrModule.forRoot(),
    StoreModule.forRoot({}, {}),

    TippyModule.forRoot({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
    }),
    NgToggleModule.forRoot(),
    // StoreModule.forRoot(reducers, {
    //   metaReducers
    // }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    VideoService,
    DatePipe,
    AuthService,
    ModalService,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
